// 请不要改动这个文件

import { cloneDeep } from 'lodash';
import { encrypt } from '@/framework/utils-project/cryptoUtil';

window.__pageBackParams__ = {};

let magicVar = `yhcRouter`;

function preHandle(id, type) {
  // 加密id
  if (id) {
    id = id + '';
    id = encrypt(id);
  }
  if (type) {
    type = encrypt(type + +new Date());
  }
  return {
    id,
    type,
  };
}

export default {
  data() {
    return {};
  },
  methods: {
    [`${magicVar}BackPage`]() {
      this.$router.back();
    },
    [`${magicVar}ToPage`](pageName, id, type = 'add') {
      if (!pageName) {
        throw Error(`${magicVar}ToPage : 必须传pageName`);
      }

      let res = preHandle(id, type);

      this.$router.push({
        name: pageName,
        query: res,
      });
    },
    [`${magicVar}ReplacePage`](pageName, id, type = 'add') {
      if (!pageName) {
        throw Error(`${magicVar}ReplacePage : 必须传pageName`);
      }

      let res = preHandle(id, type);

      this.$router.replace({
        name: pageName,
        query: res,
      });
    },
    [`${magicVar}PageBackSetParams`](key, q) {
      window.__pageBackParams__[key] = q;
    },
    [`${magicVar}PageBackGetParams`](key) {
      return cloneDeep(window.__pageBackParams__[key]);
    },
    [`${magicVar}PageBackDeleteParams`](key) {
      delete window.__pageBackParams__[key];
    },
  },
};
